// extracted by mini-css-extract-plugin
module.exports = {"divider":"FourColumnGrid_divider__D0M5D","root":"FourColumnGrid_root__3jtTS","nameBlock":"FourColumnGrid_nameBlock__2cD1x","actionsBlock":"FourColumnGrid_actionsBlock__2wjen"};